var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint20 = function SvgPrint20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#print_20_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "print_20_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.787,
    height: 5.901,
    x: 6.107,
    y: 3.933,
    rx: 0.714
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.787,
    height: 5.901,
    x: 6.107,
    y: 3.933,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#print_20_svg__b)",
    rx: 0.714
  }), /*#__PURE__*/React.createElement("mask", {
    id: "print_20_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.796,
    height: 7.201,
    x: 3.571,
    y: 7.143,
    rx: 0.714
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12.796,
    height: 7.201,
    x: 3.571,
    y: 7.143,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#print_20_svg__c)",
    rx: 0.714
  }), /*#__PURE__*/React.createElement("mask", {
    id: "print_20_svg__d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.787,
    height: 4.632,
    x: 6.107,
    y: 11.435,
    rx: 0.714
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.787,
    height: 4.632,
    x: 6.107,
    y: 11.435,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#print_20_svg__d)",
    rx: 0.714
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "print_20_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPrint20;